import Customization from "../customization";
import { ImageBlob } from "../customization/lib";
import { Controller } from "@hotwired/stimulus";
import { ImageValidation } from "../customization/image_validations";

// Connects to data-controller="site-builder--custom-images--upload"
export default class extends Controller {
  static targets = ["title", "file", "errorMessage"];
  static outlets = ["cropper"];
  static values = {
    validation: Object
  }

  connect() {
    this.imageType = document.body.dataset.imageType;
    this.validator = new ImageValidation(this.validationValue);
    this.errorMessageTarget.classList.remove('show');
  }

  handleClick(e) {
    if (e.target.id === "image-input-dropper") {
      e.preventDefault();
    }
  }

  async apply({ target }) {
    const image = target?.files[0];
    if (!image) {
      target.value = "";
      return;
    }

    this.errorMessageTarget.classList.remove('show');

    this.blob = new ImageBlob(image);
    const { url, name } = this.blob;
    const error = await this.validator.perform({ file: image, url });

    if (error) {
      this.#showError(error);
      return;
    }
    await this.cropperOutlet.use(url, name);
  }

  async render() {
    const hiddenDiv = document.querySelector('.image-view .image-cropper-details');
    const resolvedName = this.blob?.name || hiddenDiv?.getAttribute('data-original-image-name') || 'image.png';

    const applyUpdate = (blob, name = resolvedName) => {
      if (!blob) return;
      window.blobs = { ...(window.blobs || {}), [this.imageType]: blob };
      Customization.serverUpdate({ [this.imageType]: { url: blob.url, name, type: 'direct-upload' } });
      this.dispatch('applied');
    };

    if (this.cropperOutlet.hasCropped()) {
      try {
        const image = await this.cropperOutlet.getImage({ name: resolvedName });
        this.blob = new ImageBlob(image);
        applyUpdate(this.blob, resolvedName);
      } catch (err) {
        console.error('Failed to get cropped image', err);
        this.dispatch('applied');
      }
      return;
    }

    if (this.blob) {
      applyUpdate(this.blob, resolvedName);
      return;
    }

    const existingBlob = window.blobs?.[this.imageType];
    if (existingBlob) {
      Customization.serverUpdate({ [this.imageType]: { url: existingBlob.url, name: resolvedName, type: 'direct-upload' } });
      this.dispatch('applied');
      return;
    }

    this.dispatch('applied');
  }

  remove() {
    this.fileTargets.forEach((file) => {
      file.value = "";
    })
  }

  #showError(error) {
    this.validator.reset();
    this.errorMessageTarget.querySelector('.message').innerHTML = error;
    this.errorMessageTarget.classList.add('show');
  }
}
